module.exports = __webpack_public_path__ + "img/产品优势_可扩展性和灵活性.e08c78c9.png";